// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"112":"d1ccc022","505":"995d4b62","642":"2f3169ee","746":"557dc25c","760":"27da9e1b","846":"2ae807c9"}[chunkId] + ".chunk.css";
};